export default __webpack_public_path__ + "static/media/JE SUIS_1.455d86d0.svg";